module.exports = __webpack_public_path__ + "img/pic17.cf4548e8.jpg";